<template>
  <v-card
      id="wip-card"
  >
    <v-card-title
        id="wip-card-title"
        class="text-break align-center justify-center"
    >
      We're working to build a better experience.
    </v-card-title>
    <v-progress-linear
        id="wip-card-progress-linear"
        indeterminate
    />
    <v-card-text
        id="wip-card-text"
    >
      <p>
        We know you'll love it.
      </p>
      <p>
        Check back soon!
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "WorkInProgressCard"
}
</script>

<style scoped>

</style>